import {
    TableWrap,
    Table,
    THead,
    Tr,
    Th,
    TBody,
    Td,
    ActionWrap,
    EditButton,
    EditIconStyled,
    DeleteButton,
    DeleteIconStyled,
    PaginationWrap,
    TableHeader,
    SortIcon,
    Flexc
} from './newsTableElements'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment'
import { useEffect } from 'react'
import { getNews, deleteNews } from '../../store/reducer/newsSlice'
import Pagination from '@material-ui/lab/Pagination';
import { useState } from 'react'
import TableSearchForm from '../tableSearchForm'
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import { makeStyles } from '@material-ui/core'
import { unwrapResult } from '@reduxjs/toolkit'
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';

const Alert = props => {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

const useStyles = makeStyles(theme => ({
    dialogWrapper: {
        minWidth: '600px',
        position: 'absolute',
        top: theme.spacing(3)
    }
}))

const NewsTable = () => {
    const classes = useStyles()
    const dispatch = useDispatch()
    const { news, isLoading, totalRows } = useSelector(state => state.news)
    const [params, setParams] = useState({
        _page: 1,
        _limit: 8
    })
    const [sort, setSort] = useState(null)
    const [open, setOpen] = useState(false);
    const [deleteId, setDeleteId] = useState(null)
    const [openMessage, setOpenMessage] = useState(false);

    
    const handleCloseMessage = (event, reason) => {
    if (reason === 'clickaway') {
        return;
    }

    setOpenMessage(false);
    };

    const handleClickOpen = id => {
        setDeleteId(id)
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleDeleteNews = async () => {
        try {
            const actionResult = await dispatch(deleteNews(deleteId)) // delete news
            unwrapResult(actionResult)
            setOpenMessage(true)
            setOpen(false);
            await dispatch(getNews(params))
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        (async () => await dispatch(getNews(params)))() //get news
    }, [dispatch, params])

    const handleSearchChange = ({q}) => {
        setParams({...params,_page: 1, q})
    }

    const handleSort = col => {
        setSort({
            ...sort,
            col,
            type: col === sort?.col ? !sort?.type : true
        })
        setParams({...params, _sort: `${col}:${sort?.col === col ? (sort?.type? 'asc':'desc'):'desc'}`})
    }

    
    if(isLoading) return <div>Loading....</div> 


    return (
        <TableWrap>
            <TableHeader>
                <TableSearchForm onSubmit={handleSearchChange} />
            </TableHeader>
            <Table>
                <THead>
                    <Tr>
                        <Th onClick={() => handleSort('title')}><Flexc>Tiêu đề <SortIcon type={sort?.col === 'title' && sort?.type ? 'asc':'desc'} /></Flexc></Th>
                        <Th onClick={() => handleSort('description')}><Flexc>Mô tả <SortIcon type={sort?.col === 'description' && sort?.type ? 'asc':'desc'} /></Flexc></Th>
                        <Th onClick={() => handleSort('category')}><Flexc>Thể loại <SortIcon type={sort?.col === 'category' && sort?.type ? 'asc':'desc'} /></Flexc></Th>
                        <Th onClick={() => handleSort('author')}><Flexc>Tác giả <SortIcon type={sort?.col === 'author' && sort?.type ? 'asc':'desc'} /></Flexc></Th>
                        <Th onClick={() => handleSort('createdAt')}><Flexc>Ngày viết <SortIcon type={sort?.col === 'createdAt' && sort?.type ? 'asc':'desc'} /></Flexc></Th>
                        <Th>Hành động</Th>
                    </Tr>
                </THead>
                <TBody>
                    {news.map((item, index) => (
                        <Tr key={item._id}>
                            <Td>{item.title}</Td>
                            <Td>{item.description}</Td>
                            <Td>{item.category}</Td>
                            <Td>{item.author}</Td>
                            <Td>{moment(item.createdAt).format('DD/MM/yyyy')}</Td>
                            <Td>
                                <ActionWrap>
                                    <EditButton title="Chỉnh sửa" to={`/admin/news/${item._id}/edit`}><EditIconStyled /></EditButton>
                                    <DeleteButton onClick={() => handleClickOpen(item._id)} title="Xóa"><DeleteIconStyled /></DeleteButton>
                                </ActionWrap>
                            </Td>
                        </Tr>
                    ))}
                    
                </TBody>
            </Table>
            {totalRows > 8 && 
            <PaginationWrap>
                <Pagination 
                    onChange={(e, _page) => setParams({...params, _page})} 
                    count={Math.ceil(totalRows/8)} 
                    variant="outlined" 
                    shape="rounded" 
                    page={params._page}
                />
            </PaginationWrap>}
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                classes={{paper: classes.dialogWrapper}}
            >
                <DialogTitle id="alert-dialog-title">{"Bạn có chắc muốn xóa bài viết?"}</DialogTitle>
                <DialogActions>
                <Button onClick={handleDeleteNews} color="primary">
                    Xóa
                </Button>
                <Button onClick={handleClose} color="primary" autoFocus>
                    Hủy
                </Button>
                </DialogActions>
            </Dialog>
            <Snackbar 
                open={openMessage} 
                autoHideDuration={4000} 
                onClose={handleCloseMessage}
            >
                <Alert onClose={handleCloseMessage} severity="success">
                    Xóa bài viết thành công
                </Alert>
            </Snackbar>
        </TableWrap>
    )
}

export default NewsTable
